import { Injectable, Output, EventEmitter, Directive } from "@angular/core";
import { GenericLayerService } from "../services/generic-layer.service";
import { AuthenticationService } from "../services/authentication.service";
import { IUser } from "src/app/interface/user";
import { IDropdownListItem } from "../interface/DropDownListItem";

@Directive()
@Injectable()
export class CrewManagementService {
  @Output() public tasksModified: EventEmitter<any> = new EventEmitter();
  @Output() public regions: EventEmitter<any> = new EventEmitter();
  @Output() public layers: EventEmitter<any> = new EventEmitter();
  @Output() public records: EventEmitter<any> = new EventEmitter();
  public selectedRegion: any;
  public selectedLayer: any;
  public selectedDate: Date;
  public regionsList: IDropdownListItem[] = [];
  public layersList: IDropdownListItem[] = [];
  public totalrecords: any = [];

  constructor(private genericLayerService: GenericLayerService, private authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getRegions();
    this.getRecords();
  }
  currentUser: IUser;
  getRegions() {
    this.genericLayerService.getAllFeatures(this.currentUser.otherLayerIds.Regions).subscribe((regionsRes: any) => {
      const regionsSet = new Set();
      regionsRes.features.forEach((result) => {
        if (result) {
          if (result.attributes.RegionName4 != null) {
            regionsSet.add(result.attributes.RegionName4);
          }
          if (result.attributes.RegionName3 != null) {
            regionsSet.add(result.attributes.RegionName3);
          }
          if (result.attributes.RegionName2 != null) {
            regionsSet.add(result.attributes.RegionName2);
          }
        }
      });
      this.regionsList = Array.from(regionsSet).sort().map(region => ({ value: region, display: region } as IDropdownListItem));
      const it = this.regionsList.values();
      const firstregion = it.next();

      if (!this.selectedRegion) {
        this.selectedRegion = firstregion.value;
      }

      this.regions.emit(true);
    });
  }
  getLayers() {
    this.genericLayerService.getAllFeatures(this.currentUser.tableIds.tableAliasId).subscribe((regionsRes: any) => {
      //  this.filterUniqLayersList(regionsRes);
      const assetClass: IDropdownListItem[] = [];
      regionsRes.features.forEach((result) => {
        if (result) {
          if (result.attributes.GroupType === "Parent Table" || result.attributes.GroupType === "Child Table") {
            assetClass.push({ 
              value: result.attributes.Name, 
              display: this.currentUser.scndLang ? result.attributes.Alias_SL : result.attributes.Alias 
            });
          }
        }
      });
      this.layersList = assetClass.sort();

      if (!this.selectedLayer) {
        this.selectedLayer = this.layersList[0].value;
      }

      this.layers.emit(true);
    });
  }
  getRecords() {
    const SheduledDate = new Date().toLocaleDateString();
    const tomorrow = new Date(SheduledDate);
    tomorrow.setDate(tomorrow.getDate() + 2);
    // const SheduledNextDate = tomorrow.toLocaleDateString();
    // const strCond =
    //   "SheduledDate >'" +
    //   SheduledDate +
    //   "' and SheduledDate <'" +
    //   SheduledNextDate +
    //   "'" +
    //   "and EstimatedDuration is not null and EstimatedDuration > 0 and  GeomWKT  is not null";
    const strCond1 = "EstimatedDuration is not null and EstimatedDuration > 0 and  GeomWKT  is not null";
    this.genericLayerService.getFeaturesByCond(this.currentUser.tableIds.maintenanceId, strCond1).subscribe((results: any) => {
      this.totalrecords = results.features;
      this.records.emit(this.totalrecords);
    });
  }
}
